import './Knowledge.css';
import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import ProjectLevelDocumentationImage from '../assets/project-level.documentation/Project-level_documentation.jpg';
import CaseStudyDocumentationImage from '../assets/case.study.documentation/Case-study-documentation.jpg';
import ImpactLevelDocumentationImage from '../assets/impact-level.documentation/Impact-level_documentation.jpg';
import MethodLevelDocumentationImage from '../assets/method-level.documentation/Method-level_documentation.jpg';
import SucLevelDocumentationImage from '../assets/subusecase.case.results.documentation/SUC-level_documentation.jpg';
import UseCaseBibliographyDocumentationImage
    from '../assets/usecase.bibliography.documentation/Use_case_bibliography_documentation.jpg';
import knowledgeModuleForecasting
    from '../assets/project-level.documentation/Forecasting the Impacts of CCAM.pdf';
import knowledgeImpactAssessment
    from '../assets/project-level.documentation/Impact Assessment of CAVs Framework.pdf';
import socialContagion
    from '../assets/project-level.documentation/Social Contagion and CAVs.pdf';
import knowledgeMicrosimulation
    from '../assets/method-level.documentation/Microsimulation methodology.pdf';
import knowledgeCostBenefit
    from '../assets/method-level.documentation/Cost-benefit analysis methodology.pdf';
import cavParams
    from '../assets/method-level.documentation/CAV parameters.pdf';
import delphi
    from '../assets/method-level.documentation/Delphi methodology.pdf';
import mesoscopic
    from '../assets/method-level.documentation/Mesoscopic simulation.pdf';
import research
    from '../assets/method-level.documentation/Operations Research.pdf';
import system_dynamics
    from '../assets/method-level.documentation/System Dynamics.pdf';
import transferability
    from '../assets/method-level.documentation/Transferability documentation.pdf';
import freightTransport
    from '../assets/usecase.bibliography.documentation/Freight Transport.pdf';
import passengerCar
    from '../assets/usecase.bibliography.documentation/Passenger Car Transport.pdf';
import urbanTransport
    from '../assets/usecase.bibliography.documentation/Urban Transport.pdf';
import roadSafety
    from '../assets/impact-level.documentation/Road safety impacts.pdf';
import systemic
    from '../assets/impact-level.documentation/Systemic impacts.pdf';
import analysis_impacts
    from '../assets/impact-level.documentation/Cost-benefit analysis impacts.pdf';
import direct_impacts
    from '../assets/impact-level.documentation/Direct impacts.pdf';
import wider_impacts
    from '../assets/impact-level.documentation/Wider impacts.pdf';
import adac
    from '../assets/case.study.documentation/Automated Delivery and Consolidation case study.pdf';
import vienna
    from '../assets/case.study.documentation/Automated Last mile shuttles Vienna case study.pdf';
import ride_sharing
    from '../assets/case.study.documentation/Automated Ride-Sharing case study.pdf';
import glosa
    from '../assets/case.study.documentation/GLOSA case study.pdf';
import pricing
    from '../assets/case.study.documentation/Road Use Pricing case study.pdf';
import platooning
    from '../assets/case.study.documentation/Track Platooning case study.pdf';
import subusecase_1
    from '../assets/subusecase.case.results.documentation/Automated Delivery and Automated Consolidation.pdf';
import subusecase_2
    from '../assets/subusecase.case.results.documentation/Automated Ridesharing.pdf';
import subusecase_3
    from '../assets/subusecase.case.results.documentation/Dedicated Lanes for CAVs.pdf';
import subusecase_4
    from '../assets/subusecase.case.results.documentation/GLOSA.pdf';
import subusecase_5
    from '../assets/subusecase.case.results.documentation/Hub-to-hub Automated Transport.pdf';
import subusecase_6
    from '../assets/subusecase.case.results.documentation/On-demand Automated Urban Shuttle Service.pdf';
import subusecase_7
    from '../assets/subusecase.case.results.documentation/Parking Pricing Policies.pdf';
import subusecase_8
    from '../assets/subusecase.case.results.documentation/Parking Space Regulations.pdf';
import subusecase_9
    from '../assets/subusecase.case.results.documentation/Point-to-Point Automated Urban Shuttle Service.pdf';
import subusecase_10
    from '../assets/subusecase.case.results.documentation/Point-to-Point Large Scale Automated Urban Shuttle Service.pdf';
import subusecase_11
    from '../assets/subusecase.case.results.documentation/Road Use Pricing.pdf';
import subusecase_12
    from '../assets/subusecase.case.results.documentation/Truck Platooning.pdf';


import {Link} from 'react-router-dom'

function KnowledgeDocumentation(props) {

    const back = () => {
        props.history.push('/knowledge');
    }

    const projectLevelLinkTo = {
        pathname: "/documentation",
        header: 'Project-level Documentation',
        files: [{name: 'Forecasting the Impacts of CCAM', path: knowledgeModuleForecasting},
            {name: 'Impact Assessment of CAVs Framework', path: knowledgeImpactAssessment},
            {name: 'Social Contagion and CAVs', path: socialContagion},
        ]
    };

    const methodLevelLinkTo = {
        pathname: "/documentation",
        header: 'Methodological Documentation',
        files: [
            {name: 'CAV parameters', path: cavParams},
            {name: 'Cost-benefit analysis methodology', path: knowledgeCostBenefit},
            {name: 'Delphi methodology', path: delphi},
            {name: 'Mesoscopic simulation', path: mesoscopic},
            {name: 'Microsimulation methodology', path: knowledgeMicrosimulation},
            {name: 'Operations Research', path: research},
            {name: 'System Dynamics', path: system_dynamics},
            {name: 'Transferability documentation', path: transferability}
        ]
    };

    const biblioLinkTo = {
        pathname: "/documentation",
        header: 'Use-case Bibliography Documentation',
        files: [{name: 'Freight Transport', path: freightTransport},
            {name: 'Passenger Car Transport', path: passengerCar},
            {name: 'Urban Transport', path: urbanTransport}]
    };

    const impactLinkTo = {
        pathname: "/documentation",
        header: 'Impact Documentation',
        files: [
            {name: 'Cost-benefit analysis impacts', path: analysis_impacts},
            {name: 'Direct impacts', path: direct_impacts},
            {name: 'Road Safety Impacts', path: roadSafety},
            {name: 'Systemic Impacts', path: systemic},
            {name: 'Wider Impacts', path: wider_impacts}]
    };

    const caseStudyLinkTo = {
        pathname: "/documentation",
        header: 'Case Study Documentation',
        files: [{name: 'Automated Delivery and Consolidation case study', path: adac},
            {name: 'Automated Last mile shuttles Vienna case study', path: vienna},
            {name: 'Automated Ride-Sharing case study', path: ride_sharing},
            {name: 'GLOSA case study', path: glosa},
            {name: 'Road Use Pricing case study', path: pricing},
            {name: 'Track Platooning case study', path: platooning}]
    };

    const subUseCaseResultLinkTo = {
        pathname: "/documentation",
        header: 'Sub Use-case Level Documentation',
        files: [{name: 'Automated Delivery and Automated Consolidation', path: subusecase_1},
            {name: 'Automated Ridesharing', path: subusecase_2},
            {name: 'Dedicated Lanes for CAVs', path: subusecase_3},
            {name: 'GLOSA', path: subusecase_4},
            {name: 'Hub-to-hub Automated Transport', path: subusecase_5},
            {name: 'On-demand Automated Urban Shuttle Service', path: subusecase_6},
            {name: 'Parking Pricing Policies', path: subusecase_7},
            {name: 'Parking Space Regulations', path: subusecase_8},
            {name: 'Point-to-Point Automated Urban Shuttle Service', path: subusecase_9},
            {name: 'Point-to-Point Large Scale Automated Urban Shuttle Service', path: subusecase_10},
            {name: 'Road Use Pricing', path: subusecase_11},
            {name: 'Truck Platooning', path: subusecase_12}
        ]
    };

    return (
        <Container className="container knowledge">
            <Row className="mt-4">
                <a href="" onClick={back} className="btn btn-outline-primary btn-sm">Back</a>
            </Row>
            <Row className="pb-4 pt-4">
                <h3>User Documentation</h3>
            </Row>
            <Row className="mt-4 mb-2 pt-2 pb-4">
                <Col className="col-4">
                    <div className="card">
                        <Link to={projectLevelLinkTo}>
                            <img src={ProjectLevelDocumentationImage} className="card-img-top"/>
                            <div className="card-body">
                                <h5 className="card-title">Project-level Documentation</h5>
                            </div>
                        </Link>
                    </div>
                </Col>
                <Col className="text-center col-4">
                    <div className="card">
                        <Link to={impactLinkTo}>
                            <img src={ImpactLevelDocumentationImage} className="card-img-top"/>
                            <div className="card-body">
                                <h5 className="card-title">Impact Documentation</h5>
                            </div>
                        </Link>
                    </div>
                </Col>
                <Col className="text-center col-4">
                    <div className="card">
                        <Link to={methodLevelLinkTo}>
                            <img src={MethodLevelDocumentationImage} className="card-img-top"/>
                            <div className="card-body">
                                <h5 className="card-title">Methodological Documentation</h5>
                            </div>
                        </Link>
                    </div>
                </Col>
            </Row>
            <Row className="mb-4">
                <Col className="text-center col-4">
                    <div className="card">
                        <Link to={biblioLinkTo}>
                            <img src={UseCaseBibliographyDocumentationImage} className="card-img-top"/>
                            <div className="card-body">
                                <h5 className="card-title">Use-case Bibliography Documentation</h5>
                            </div>
                        </Link>
                    </div>
                </Col>
                <Col className="text-center col-4">
                    <div className="card">
                        <Link to={subUseCaseResultLinkTo}>
                            <img src={SucLevelDocumentationImage} className="card-img-top"/>
                            <div className="card-body">
                                <h5 className="card-title">Sub Use-case Level Documentation</h5>
                            </div>
                        </Link>
                    </div>
                </Col>
                <Col className="text-center col-4">
                    <div className="card">
                        <Link to={caseStudyLinkTo}>
                            <img src={CaseStudyDocumentationImage} className="card-img-top"/>
                            <div className="card-body">
                                <h5 className="card-title">Case Study Documentation</h5>
                            </div>
                        </Link>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default KnowledgeDocumentation;
